/* eslint-disable unused-imports/no-unused-vars */
import { MenuItem } from '@chakra-ui/react'
import { FC } from 'react'
import { GrDocumentCsv } from 'react-icons/gr'

import useKpiStorage from '@hook/kpi/use-storage'
import useTools from '@hook/shared/use-tools'

import { parseSalesKpiData } from '@helper/kpi/sales/parseSalesKpiData'

import { ILayoutToolsExportAction } from '@base/@types/components/Layout/Tools'
const ExcelStorangeKpi: FC<ILayoutToolsExportAction> = ({
  headers,
  parser = parseSalesKpiData
}) => {
  const { isDisabled } = useTools()

  const { exportKpiData } = useKpiStorage()

  return (
    <>
      <MenuItem
        p="2px 12px"
        fontSize="sm"
        bgColor="white"
        _hover={{ bg: 'gray.400' }}
        isDisabled={isDisabled}
        onClick={exportKpiData}
        icon={<GrDocumentCsv />}
      >
        Exportar para Tabela
      </MenuItem>
    </>
  )
}
export default ExcelStorangeKpi
